/** PDP (product detail page) view counts — shared by storefront home + admin analytics UI. */

export function getProductId(product) {
  return String(product?._id ?? product?.id ?? product?.productId ?? '').trim();
}

export function getViewCountFromRow(row) {
  const v =
    row?.pdpViewCount ??
    row?.views ??
    row?.viewCount ??
    row?.count ??
    0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function buildViewsMap(topProducts = []) {
  const map = new Map();
  if (!Array.isArray(topProducts)) return map;
  for (const row of topProducts) {
    const pid = String(row?.productId ?? row?._id ?? row?.id ?? '').trim();
    if (!pid) continue;
    map.set(pid, getViewCountFromRow(row));
  }
  return map;
}

export function mergeProductViews(products, viewsMap) {
  return (products || []).map((p) => {
    const pid = getProductId(p);
    const fromProduct = p.views ?? p.viewCount ?? p.pdpViews;
    const fromMap = viewsMap.get(pid);
    const raw = fromMap ?? (fromProduct != null ? Number(fromProduct) : 0);
    const n = Number(raw);
    return {
      ...p,
      pdpViewCount: Number.isFinite(n) && n >= 0 ? n : 0,
    };
  });
}

export function sumPdpViews(products) {
  return (products || []).reduce((sum, p) => sum + (p.pdpViewCount ?? getViewCountFromRow(p)), 0);
}
